import { Link } from 'react-router';

import StackedBoxes2 from 'images/zappos/stacked-boxes-2.svg';

import css from 'styles/components/productdetail/shippingAndReturnsBanner.scss';

const ShippingAndReturnsBanner = () => (
  <div className={css.container}>
    <h2 className={css.heading}>Free Shipping and Free Returns</h2>
    <div>
      {/* Since the below image is purely decorative, ensure empty alt text to signal screen readers to ignore */}
      <img className={css.image} src={StackedBoxes2} alt=""/>
      <div className={css.text}>
        <div className={css.infoWrapper}>
          <p className={css.info}>
            If, for any reason, you are unsatisfied with your purchase from
            Zappos Retail, Inc. you may return it in its original condition
            within 365 days for a refund. We'll even pay for return shipping!
          </p>
        </div>
        <Link to="/c/shipping-and-returns" className={css.link}>Learn more about our free shipping and free returns policy</Link>
      </div>
    </div>
  </div>
);

export default ShippingAndReturnsBanner;
